import React from 'react';
import { createClub, updateResponse, getAllClubs } from "../../api/clubapi";
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Form, Input, Label, Button, Row, Col } from 'reactstrap';
import CustomDatePicker from '../CustomDatePicker';
import PopupError from '../PopupError';
import FormValidator from '../FormValidation';
import RequiredFieldNotation from '../utils/RequiredFieldNotation';
import feedback from '../utils/feedback';
import InputFeedback from '../utils/InputFeedback';
import '../css/EditCreate.css';
class ClubCreate extends React.Component {

    constructor(props) {
        super(props);
        this.props.route.history.push('/secure/clubs');
        this.props.route.history.push(this.props.route.match.url);
        this.validator = new FormValidator([
            {
                field: 'name',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'clubCode',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'clubCode',
                method: 'isNumeric',
                //args: [{ min: 21, max: 65 }],
                validWhen: true,
                message: 'Value must be a number.'
            },
            // {
            //     field: 'routerType',
            //     method: 'isEmpty',
            //     validWhen: false,
            //     message: 'Router Type is required.'
            // },
            {
                field: 'routerCredentials',
                method: 'isLength',
                args: [{ min: 0, max: 500 }],
                validWhen: true,
                message: 'Value maximum length surpassed.'
            },
            {
                field: 'startDate',
                method: this.isBefore,
                validWhen: true,
                message: 'Start date must be before end date.'
            },
            {
                field: 'customerServiceEmail',
                method: (fieldValue) => {
                    if (fieldValue.trim() === '') {
                        return false
                    }

                    return this.isEmail(fieldValue);
                },
                validWhen: false,
                message: 'Please enter valid emails.'
            }
        ])
        this.state = {
            club: {
                name: '',
                clubCode: '',
                routerCredentials: '',
                routerConnection: '',
                routerType: '',
                FTPHost: '',
                FTPPort: '',
                startDate: '',
                endDate: '',
                parentClubName: '',
                customerServiceEmail: ''
            },
            clubs: [],
            cancel: false,
            saved: false,
            error: false,
            errorMessage: [],
            validation: this.validator.valid(),
            clubId: ''
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    isBefore = (confirmation, state) => (state.endDate >= confirmation || !state.endDate);
    isAfter = (confirmation, state) => (state.startDate <= confirmation);
    isEmail = (state) => {
        return (!state.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25}(;[ ]{0,1}([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})*$/));
    }

    componentDidUpdate(prevProps) {
        //Checks if there is a response on update
        if (this.props.updateResult !== prevProps.updateResult) {
            var result = this.props.updateResult
            //Checks if the response is success or has errors.
            if (result) {
                if (result.data.success) {
                    this.setState(state => ({
                        saved: true,
                        clubId: result.data.data.clubId,
                        club: result.data.data
                    }));
                } else if (result.data.success == false) {
                    var errorList = [];
                    result.data.errors.map(function (e) { errorList.push(e.message) })
                    this.setState({ error: true, errorMessage: errorList })
                }
                else {
                    let message = Object.keys(result.data.errors).map((function (e) { return 'there was an error saving ' + e }));
                    this.setState({ error: true, errorMessage: message });
                }
                this.props.updateResponse("");
            }
        }
    }


    componentDidMount() {
        this.props.getAllClubs(function (result, _this) { _this.getData(result, _this) }, this)
        this.setState({
            loading: true
        })
    }

    renderClubNames() {
        let clubs = this.state.clubs;
        return clubs.map((club, index) => {
            return (
                <option id={club.clubId} key={index}>{club.name}</option>
            );
        });
    }

    getData(data, _this) {
        //Unshift adds an empty value to the start of the array, for creating an empty <option> tag
        let parentClubs = data.data.data;
        parentClubs.unshift("");
        _this.setState({
            clubs: parentClubs,
            loading: false
        })
    }

    handleFormSubmit = event => {
        event.preventDefault();

        var updVal = this.state.club;
        updVal.startDate = document.getElementById("startDate").value;
        updVal.endDate = document.getElementById("endDate").value;
        this.setState({ club: updVal }, () => {
            const validation = this.validator.validate(this.state.club);
            this.setState({ validation });
            this.submitted = true;
            if (validation.isValid) {
                // handle actual form submission here
                console.log(updVal, "club");
                this.props.createClub(updVal);
            }
        });
    }

    //Redirects to club list
    handleCancel = () => {
        this.setState({
            cancel: true
        })
    }

    isInvalid(e) {
        var input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
    }

    //Closes the popup when the X is clicked or click outside the modal.
    closeModal() {
        this.setState({ error: false });
    }

    render() {
        const club = this.state.club;

        //Redirects to club when canceled
        if (this.state.cancel) {
            return <Redirect
                to={{
                    pathname: `/secure/clubs`,
                }}
            />;
        }

        //Redirects to clubs when succesfully saved
        if (this.state.saved) {
            return <Redirect
                to={{
                    pathname: `/secure/clubEdit/${this.state.clubId}`,
                    state: { clubCreate: this.state.club }
                }}
            />;
        }

        let validation = this.submitted ?                         // if the form has been submitted at least once
            this.validator.validate(this.state.club) :   // then check validity every time we render
            this.state.validation                   // otherwise just use what's in state
        if (document.querySelector('.nativeDatePicker')) document.querySelector('.nativeDatePicker').style.display = 'none';
        return (
            <div className="card">

                <PopupError
                    open={this.state.error}
                    onClose={this.closeModal}
                    onClick={this.closeModal}
                    errorMessage={this.state.errorMessage} />

                <div className="card-header text-center"> Add Club</div>
                <div className="card-body fs-12">
                    <Form onSubmit={this.handleSubmit}>
                        <RequiredFieldNotation />
                        <div className="row">
                            <div className="col-md-6">
                                <Col className={`${validation.name.isInvalid ? 'has-error' : ''}`}>
                                    <Label htmlFor='clubName' className="required-hint mt-4"><strong>Club</strong></Label>
                                    <Input
                                        id="clubName"
                                        type="input"
                                        name="name"
                                        className="input-editable"
                                        maxLength="150"
                                        autoComplete="off"
                                        // required
                                        value={club.name}
                                        onChange={(e) => { this.isInvalid(e); var x = club; x.name = e.target.value; this.setState({ club: x }) }} />
                                    <span className="help-block">{validation.name.message}</span>
                                </Col>
                                <Col className={`${validation.clubCode.isInvalid ? 'has-error' : ''}`} >
                                    <Label htmlFor='clubCode' className="required-hint mt-4"><strong>Club code</strong></Label>
                                    <Input
                                        type="number"
                                        name="clubCode"
                                        id='clubCode'
                                        className="input-editable"
                                        // required
                                        value={club.clubCode}
                                        onChange={(e) => { this.isInvalid(e); var x = club; x.clubCode = e.target.value; this.setState({ club: x }) }} />
                                    <InputFeedback feedbackText={feedback.clubCode} id='clubCode' />
                                    <span className="help-block">{validation.clubCode.message}</span>
                                </Col>
                                <Col>
                                    <Label htmlFor='parentClubId' className="mt-4"><strong>Parent club</strong></Label>
                                    <label className="select">
                                        <select
                                            id="parentClubId"
                                            name="parentClubId"
                                            className="form-control input-editable"
                                            onChange={(e) => {
                                                var x = this.state.club; x.parentClubName = e.target.value;
                                                var y = this.state.club; y.parentClubId = e.target[e.target.selectedIndex].getAttribute('id');
                                                this.setState({ club: y, club: x })
                                            }}
                                        >
                                            {this.renderClubNames()}
                                        </select>
                                    </label>
                                </Col>
                                <Row>
                                    <div className="col-md-6">
                                        <Col className={`${validation.startDate.isInvalid ? 'has-error' : ''}`}>
                                            <Label htmlFor='startDate' className="mt-4" ><strong>Start date</strong></Label>
                                            <CustomDatePicker
                                                id="startDate"
                                                readOnly={false}
                                                defValue={club.startDate.substring(0, 10)}
                                                label="Start Date"
                                            />
                                            <InputFeedback feedbackText={feedback.startDate} id='startDate' />
                                            <span className="help-block-calendar">{validation.startDate.message}</span>
                                        </Col>
                                    </div>
                                    <div className="col-md-6">
                                        <Col>
                                            <Label htmlFor='endDate' className="mt-4"><strong>End date</strong></Label>
                                            <CustomDatePicker
                                                id="endDate"
                                                readOnly={false}
                                                defValue={club.endDate.substring(0, 10)}
                                                label="End Date"
                                            />
                                        </Col>
                                    </div>
                                </Row>
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    <Label htmlFor='routerType' className="mt-4"><strong>Transfer method</strong></Label>
                                    <label className="select">
                                        <select
                                            id="routerType"
                                            name="routerType"
                                            value={this.state.club.routerType}
                                            className="input-editable form-control"
                                            onChange={(e) => { var x = this.state.club; x.routerType = e.target.value; this.setState({ club: x }) }}>
                                            <option></option>
                                            <option>FTP</option>
                                            <option>Service BUS</option>
                                            <option>Bulk FTP</option>
                                        </select>
                                    </label>
                                </Col>
                                <Col>
                                    <Label htmlFor='routerConnection' className="mt-4"><strong>Router connection</strong></Label>
                                    <Input
                                        type="textarea"
                                        className="input-editable txt-input-size"
                                        name="routerConnection"
                                        id='routerConnection'
                                        maxLength="500"
                                        onChange={(e) => { var x = club; x.routerConnection = e.target.value; this.setState({ club: x }) }}
                                        value={club.routerConnection} />
                                    <InputFeedback feedbackText={feedback.routerConnection} id='routerConnection' />
                                </Col>
                                <Col className={`${validation.routerCredentials.isInvalid ? 'has-error' : ''}`}>
                                    <Label htmlFor='routerCredentials' className="mt-4"><strong>Router credentials</strong></Label>
                                    <Input
                                        type="input"
                                        className="input-editable"
                                        name="routerCredentials"
                                        id='routerCredentials'
                                        maxLength="500"
                                        onChange={(e) => { var x = club; x.routerCredentials = e.target.value; this.setState({ club: x }) }}
                                        value={club.routerCredentials} />
                                    <InputFeedback feedbackText={feedback.routerCredentials} id='routerCredentials' />
                                    <span className="help-block">{validation.routerCredentials.message}</span>
                                </Col>
                                <Row>
                                    <div className="col-md-6">
                                        <Col>
                                            <Label htmlFor='ftpHost' className="mt-4"><strong>FTP host</strong></Label>
                                            <Input
                                                type="input"
                                                className="input-editable"
                                                id='ftpHost'
                                                name="FTPHost" value={this.state.club.FTPHost}
                                                onChange={(e) => { var x = this.state.club; x.FTPHost = e.target.value; this.setState({ club: x }) }} />
                                            <InputFeedback feedbackText={feedback.ftpHost} id='ftpHost' />
                                        </Col>
                                    </div>
                                    <div className="col-md-6">
                                        <Col>
                                            <Label htmlFor='ftpPort' className="mt-4"><strong>FTP port</strong></Label>
                                            <Input
                                                type="number"
                                                className="input-editable"
                                                id='ftpPort'
                                                name="FTPPort" value={this.state.club.FTPPort}
                                                onChange={(e) => { var x = this.state.club; x.FTPPort = e.target.value; this.setState({ club: x }) }} />
                                            <InputFeedback feedbackText={feedback.ftpPort} id='ftpPort' />
                                        </Col>
                                    </div>
                                </Row>
                                <Row>
                                    <div className={`${validation.customerServiceEmail.isInvalid ? 'col-md-12 has-error' : 'col-md-12'}`}>
                                        <Col>
                                            <Label htmlFor='email' className="mt-4"><strong>Customer Service Email</strong></Label>
                                            <Input
                                                readOnly={this.state.readOnly}
                                                type="text"
                                                maxLength="256"
                                                name="customerServiceEmail"
                                                autoComplete="off"
                                                id='email'
                                                className={this.state.readOnly ? '' : 'input-editable form-control'}
                                                value={club.customerServiceEmail}
                                                onChange={(e) => { this.isInvalid(e); var x = club; x.customerServiceEmail = e.target.value; this.setState({ club: x }) }} />
                                            <InputFeedback feedbackText={feedback.email} id='email' />
                                            <span className="help-block">{validation.customerServiceEmail.message}</span>
                                        </Col>
                                    </div>
                                </Row>
                                <div className="text-right float-bottom">
                                    <Button onClick={this.handleCancel.bind(this)} className="cancel-btn">CANCEL</Button>
                                    <Button type="submit" onClick={e => this.handleFormSubmit(e)} className="save-btn">SAVE</Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}
export default connect(
    state => {
        return {
            updateResult: state.data.updateResult,
            clubs: state.data.clubs
        }
    },
    dispatch => ({
        createClub: (club) => { dispatch(createClub(club)) },
        updateResponse: (response) => { dispatch(updateResponse(response)) },
        getAllClubs: (callback, context) => { dispatch(getAllClubs(callback, context)) }
    }
    )
)(ClubCreate);